var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { staticClass: "search-bar", class: { mobile: _vm.mobileBigAndBelow } },
    [
      _c(
        "div",
        {
          staticClass: "input-group",
          class: { "non-empty": _vm.searchPhrase }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSearchFields,
                  expression: "showSearchFields"
                }
              ],
              staticClass: "search-fields-container"
            },
            [
              _c("button", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchPhrase,
                    expression: "searchPhrase"
                  }
                ],
                staticClass: "back-icon",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.goBack()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.searchPhrase,
                      expression: "!searchPhrase"
                    }
                  ],
                  staticClass: "search-icon",
                  on: {
                    click: function($event) {
                      return _vm.toggleShowSearchPopup()
                    }
                  }
                },
                [_c("icon", { attrs: { name: "icon-search" } })],
                1
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchPhrase,
                    expression: "searchPhrase"
                  }
                ],
                ref: "phrase",
                staticClass: "search-filed",
                attrs: {
                  type: "search",
                  name: "search-filed",
                  placeholder: _vm.$t("Casino.Search.Input.Placeholder"),
                  autocomplete: "off"
                },
                domProps: { value: _vm.searchPhrase },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchPhrase = $event.target.value
                    },
                    _vm.handleSearchInput
                  ],
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.performSetPhraseAndSearchSearch(true)
                  }
                }
              }),
              _vm._v(" "),
              _c("button", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchPhrase,
                    expression: "searchPhrase"
                  }
                ],
                staticClass: "reset-icon",
                attrs: { type: "reset" },
                on: {
                  click: function($event) {
                    return _vm.resetSearchPhrase()
                  }
                }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-237066ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237066ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoSearch/casinoSearchBar.vue
// module id = null
// module chunks = 